module.exports = {"623024100":"电尕镇","623024101":"益哇镇","623024102":"旺藏镇","623024103":"腊子口镇","623024104":"洛大镇","623024201":"卡坝乡","623024202":"达拉乡","623024203":"尼傲乡","623024205":"阿夏乡","623024206":"多儿乡","623024207":"桑坝乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/623024.json
// module id = 3114
// module chunks = 0